import {
  LOGIN_SUCCESS,
  REGISTER_SUCCESS,
  VERIFY_OTP,
  RESEND_OTP,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  CONTACT_MESSAGE,
  GET_STARTED_VIDEOS,
  GET_FAQ,
  GET_NOTIFICATION,
  READ_NOTIFICATION,
  UPDATE_SUBSCRIBE,
  ADD_CARD_DETAIL,
  BUY_SUBSCRIPTION,
  GET_ACADEMY_STUDENT,
  CHECK_SUBSCRIPTION_BY_EMAIL,
  VERIFY_SUBSCRIPTION_OTP,
  DELETE_ACADEMY_STUDENT,
  ADD_CARD_TRIAL,
  ADD_ACADEMY_ENQUIRY,
  CREATE_FEEDBACK_TICKET,
  CANCEL_SUBSCRIPTION,
  BUY_ACADEMY_SUBSCRIPTION,
  GET_ACTIVE_SUBSCRIPTION,
  CANCEL_ACADEMY_SUBCRIPTION,
  ATTACH_CARD_TO_USER,
  GET_PAYMENT_METHODS,
  SET_AS_DEFAULT_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD,
} from "./types";
import { baseUrl } from "../constants/const";
import { apiCall } from "../../api";
// const bulletToken = localStorage.getItem("token")??""

export const loginUser = (data, successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${baseUrl}user/login`,
    data,
  };

  let response = await apiCall(config, dispatch);

  if (response?.data?.status) {
    // window.location.reload();
    successCb(response?.data);
  } else {
    failureCb(response);
  }
  dispatch({
    type: LOGIN_SUCCESS,
    payload: response?.data,
  });
};

export const registerUser =
  ({ formData, successCb, failureCb }) =>
  async (dispatch) => {
    let config = {
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      url: `${baseUrl}user/register`,
      data: formData,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
    dispatch({
      type: REGISTER_SUCCESS,
      payload: response?.data,
    });
  };
/************Academy flow action start**************** */
export const registerAcademy =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      url: `${baseUrl}user/register_academy`,
      data,
    };
    try {
      let response = await apiCall(config, dispatch);
      if (response?.data?.status) {
        successCb(response?.data);
      } else {
        failureCb(response);
      }
    } catch (error) {
      failureCb(error);
    }
  };

/************Academy flow action End**************** */

export const verifyOtp = (data, successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${baseUrl}user/verify_otp`,
    data,
  };

  let response = await apiCall(config, dispatch);

  if (response?.data?.status) {
    successCb(response?.data);
  } else {
    failureCb(response);
  }
  dispatch({
    type: VERIFY_OTP,
    payload: response?.data,
  });
};

export const resendOtp = (data, successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${baseUrl}user/resend_otp`,
    data,
  };

  let response = await apiCall(config, dispatch);
  if (response?.data?.status) {
    successCb(response?.data);
    dispatch({
      type: RESEND_OTP,
      payload: response?.data,
    });
  } else {
    failureCb(response?.data);
  }
};

export const forgotPassword =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${baseUrl}user/forgot`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
    dispatch({
      type: FORGOT_PASSWORD,
      payload: response?.data,
    });
  };

export const resetPassword =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${baseUrl}user/reset_password`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
    dispatch({
      type: RESET_PASSWORD,
      payload: response?.data,
    });
  };

export const changePassword =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/changePassword`,
      data,
    };
    console.log(data);
    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
    dispatch({
      type: CHANGE_PASSWORD,
      payload: response?.data,
    });
  };

export const contactUsData =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${baseUrl}user/contact_us`,
      data,
    };
    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: CONTACT_MESSAGE,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const getStartedVideos = (successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: `${baseUrl}user/get_started_video`,
  };
  let response = await apiCall(config, dispatch);
  if (response?.data?.status) {
    successCb(response?.data);
    dispatch({
      type: GET_STARTED_VIDEOS,
      payload: response?.data,
    });
  } else {
    failureCb(response);
  }
};

export const getFaq = (data, successCb, failureCb) => async (dispatch) => {
  try {
    let config = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${baseUrl}user/get_faq`,
      data,
    };
    let response = await apiCall(config, dispatch);

    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: GET_FAQ,
        payload: response?.data,
      });
    } else {
      // Ensure that failureCb is a function before calling it
      if (typeof failureCb === "function") {
        // Assuming failureCb takes a parameter
        failureCb(response?.data);
      } else {
        console.error("failureCb is not a function");
      }
    }
  } catch (error) {
    // Handle network errors or other exceptions here
    console.error("Error in getFaq:", error);

    // Ensure that failureCb is a function before calling it
    if (typeof failureCb === "function") {
      // Assuming failureCb also takes a parameter for errors
      failureCb(error);
    } else {
      console.error("failureCb is not a function");
    }
  }
};

export const getNotification = (successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    url: `${baseUrl}user/get_notification`,
  };
  let response = await apiCall(config, dispatch);
  if (response?.data?.status) {
    successCb(response?.data);

    dispatch({
      type: GET_NOTIFICATION,
      payload: response?.data,
    });
  } else {
    failureCb(response?.data);
  }
};

export const readAllNotification =
  (successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/unread_notification_count`,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: READ_NOTIFICATION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

// Subscription Action Start
export const addCardDetail =
  (data, successCb, failureCb) => async (dispatch) => {
    // alert("jhfdjs")
    console.log("================", localStorage.getItem("token"));
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/add_card_after_login`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: ADD_CARD_DETAIL,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const addCardDetailAfterLogin =
  (data, successCb, failureCb) => async (dispatch) => {
    // alert("jhfdjs")
    console.log("================", localStorage.getItem("token"));
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/add_card_after_login`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: ADD_CARD_DETAIL,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const updatePaymentCard =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/addCardMakeDefault`,
      data,
    };
    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
  };

export const buySubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/buy_subscription`,
      data,
    };

    console.log(config, ">>>>>>>>>>>config");
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: BUY_SUBSCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const buyAcademySubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/create-checkout-session`,
      data,
    };

    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.result?.status) {
      successCb(response?.data?.result?.data);
      dispatch({
        type: BUY_ACADEMY_SUBSCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const buyUserSubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/user_buy_subscription`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data?.data);
      dispatch({
        type: BUY_SUBSCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const buyUserTrialSubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/test_buy_trial_subscription`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data?.data);
      dispatch({
        type: BUY_ACADEMY_SUBSCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const getActiveLatestSubscription =
  (successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/get-active-subscriptions-by-user`,
    };

    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: GET_ACTIVE_SUBSCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const createOrRetrieveCustomerAndAttachPaymentMethod =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/attach-payment-method-to-customer`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: ATTACH_CARD_TO_USER,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const setDefaultPaymentMethod =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/set-default-payment-method`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: SET_AS_DEFAULT_PAYMENT_METHOD,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const deletePaymentMethod =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/delete-payment-method`,
      data,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: DELETE_PAYMENT_METHOD,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const getUserPaymentMethods =
  (successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}academy-subscriptions/get-user-payment-methods`,
    };

    let response = await apiCall(config, dispatch);
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: GET_PAYMENT_METHODS,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const cancelAcademySubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      url: `${baseUrl}academy-subscriptions/cancel-subcription`,
      data,
    };

    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.result?.status) {
      successCb(response?.data?.result);
      dispatch({
        type: CANCEL_ACADEMY_SUBCRIPTION,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const updateSubscriptionStatus =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/update_subscription_status`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: UPDATE_SUBSCRIBE,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const buyTrialSubscription =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/buy_trial_subscription`,
      data,
    };
    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
    } else {
      failureCb(response);
    }
  };

export const getAcademyStudents =
  (successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/get_my_academy_students`,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: GET_ACADEMY_STUDENT,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const deleteAcademyStudent =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/delete_academy_students`,
      data,
    };
    let response = await apiCall(config, dispatch);
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: DELETE_ACADEMY_STUDENT,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const checkSubscriptionByEmail =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/check_subscription_by_email`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: CHECK_SUBSCRIPTION_BY_EMAIL,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const verifySubscriptionOtp =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/verify_subscription_otp`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: VERIFY_SUBSCRIPTION_OTP,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const addCardForTrial =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/add_card_for_trial_subscription`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: ADD_CARD_TRIAL,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const addAcademyEnquiry =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/add_academy_enquiry`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: ADD_ACADEMY_ENQUIRY,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const createFeedbackTicket =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/create_ticket`,
      data,
    };
    let response = await apiCall(config, dispatch);
    // console.log(response?.data, "response")
    if (response?.data?.status) {
      successCb(response?.data);
      dispatch({
        type: CREATE_FEEDBACK_TICKET,
        payload: response?.data,
      });
    } else {
      failureCb(response);
    }
  };

export const cancelSubsciption = (successCb, failureCb) => async (dispatch) => {
  let config = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    url: `${baseUrl}user/cancel_subscription`,
  };
  let response = await apiCall(config, dispatch);
  // console.log(response?.data, "response")
  if (response?.data?.status) {
    successCb(response?.data);
    dispatch({
      type: CANCEL_SUBSCRIPTION,
      payload: response?.data,
    });
  } else {
    failureCb(response);
  }
};

export const verifyPromoCode =
  (data, successCb, failureCb) => async (dispatch) => {
    let config = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${baseUrl}user/verify_subscription_coupon_code`,
      data,
    };

    let response = await apiCall(config, dispatch);
    try {
      if (response?.data?.status) {
        successCb(response?.data);
        // dispatch({
        //     type: CREATE_FEEDBACK_TICKET,
        //     payload: response?.data,
        // });
      } else {
        failureCb(response);
      }
    } catch (error) {
      failureCb(error);
    }
  };
